export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Wip 1_07.98b01c48.jpg";